/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ApplicationFirstStageDataCustomerOrganizationData } from './ApplicationFirstStageDataCustomerOrganizationData'
import {
  ApplicationFirstStageDataCustomerOrganizationDataFromJSON,
  ApplicationFirstStageDataCustomerOrganizationDataFromJSONTyped,
  ApplicationFirstStageDataCustomerOrganizationDataToJSON,
} from './ApplicationFirstStageDataCustomerOrganizationData'
import type { OrganizationType } from './OrganizationType'
import {
  OrganizationTypeFromJSON,
  OrganizationTypeFromJSONTyped,
  OrganizationTypeToJSON,
} from './OrganizationType'
import type { ImageSignType } from './ImageSignType'
import {
  ImageSignTypeFromJSON,
  ImageSignTypeFromJSONTyped,
  ImageSignTypeToJSON,
} from './ImageSignType'

/**
 *
 * @export
 * @interface ApplicationFirstStageData
 */
export interface ApplicationFirstStageData {
  /**
   * Если указывается наименование, поля file, imageSighType не должны передаваться
   * @type {string}
   * @memberof ApplicationFirstStageData
   */
  brand?: string
  /**
   *
   * @type {string}
   * @memberof ApplicationFirstStageData
   */
  image?: string
  /**
   *
   * @type {ImageSignType}
   * @memberof ApplicationFirstStageData
   */
  imageType?: ImageSignType
  /**
   * Признак совпадения данных заказчик (кто подает) и правообладателя (на кого подают)
   * @type {boolean}
   * @memberof ApplicationFirstStageData
   */
  isEqual?: boolean
  /**
   *
   * @type {OrganizationType}
   * @memberof ApplicationFirstStageData
   */
  customerOrganizationType?: OrganizationType
  /**
   *
   * @type {OrganizationType}
   * @memberof ApplicationFirstStageData
   */
  ownerOrganizationType?: OrganizationType
  /**
   *
   * @type {ApplicationFirstStageDataCustomerOrganizationData}
   * @memberof ApplicationFirstStageData
   */
  customerOrganizationData?: ApplicationFirstStageDataCustomerOrganizationData
  /**
   *
   * @type {ApplicationFirstStageDataCustomerOrganizationData}
   * @memberof ApplicationFirstStageData
   */
  ownerOrganizationData?: ApplicationFirstStageDataCustomerOrganizationData
}

/**
 * Check if a given object implements the ApplicationFirstStageData interface.
 */
export function instanceOfApplicationFirstStageData(
  value: object
): value is ApplicationFirstStageData {
  return true
}

export function ApplicationFirstStageDataFromJSON(
  json: any
): ApplicationFirstStageData {
  return ApplicationFirstStageDataFromJSONTyped(json, false)
}

export function ApplicationFirstStageDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApplicationFirstStageData {
  if (json == null) {
    return json
  }
  return {
    brand: json['brand'] == null ? undefined : json['brand'],
    image: json['image'] == null ? undefined : json['image'],
    imageType:
      json['imageType'] == null
        ? undefined
        : ImageSignTypeFromJSON(json['imageType']),
    isEqual: json['isEqual'] == null ? undefined : json['isEqual'],
    customerOrganizationType:
      json['customerOrganizationType'] == null
        ? undefined
        : OrganizationTypeFromJSON(json['customerOrganizationType']),
    ownerOrganizationType:
      json['ownerOrganizationType'] == null
        ? undefined
        : OrganizationTypeFromJSON(json['ownerOrganizationType']),
    customerOrganizationData:
      json['customerOrganizationData'] == null
        ? undefined
        : ApplicationFirstStageDataCustomerOrganizationDataFromJSON(
            json['customerOrganizationData']
          ),
    ownerOrganizationData:
      json['ownerOrganizationData'] == null
        ? undefined
        : ApplicationFirstStageDataCustomerOrganizationDataFromJSON(
            json['ownerOrganizationData']
          ),
  }
}

export function ApplicationFirstStageDataToJSON(
  value?: ApplicationFirstStageData | null
): any {
  if (value == null) {
    return value
  }
  return {
    brand: value['brand'],
    image: value['image'],
    imageType: ImageSignTypeToJSON(value['imageType']),
    isEqual: value['isEqual'],
    customerOrganizationType: OrganizationTypeToJSON(
      value['customerOrganizationType']
    ),
    ownerOrganizationType: OrganizationTypeToJSON(
      value['ownerOrganizationType']
    ),
    customerOrganizationData:
      ApplicationFirstStageDataCustomerOrganizationDataToJSON(
        value['customerOrganizationData']
      ),
    ownerOrganizationData:
      ApplicationFirstStageDataCustomerOrganizationDataToJSON(
        value['ownerOrganizationData']
      ),
  }
}
